import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/auth.service";
import { DataServiceService } from "src/app/data-service.service";
import { User } from "../../model/login";

@Component({
  selector: "app-new-print-history-header",
  templateUrl: "./new-print-history-header.component.html",
  styleUrls: ["./new-print-history-header.component.scss"],
})
export class NewPrintHistoryHeaderComponent implements OnInit {
  public hongKongDT;
  public companyName;
  userDetails: User;
  isLoading: boolean = true;
  historyData: object
  constructor(
    private dataService: DataServiceService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.historyData = JSON.parse(localStorage.getItem("historyData"));
    this.getUserDetails().then((data) => {
      this.isLoading = false;
    });
  }

  async getUserDetails() {
    this.userDetails = await this.dataService.getUserDetailsById(
      this.authService.getCurrentUser().userId
    );
    this.userDetails = this.userDetails[0];
  }
} 